/**
 * Cookie utility functions for client-side cookie management
 */

/**
 * Get the cookie domain from environment or fallback to default
 */
const getCookieDomain = (): string => {
    return process.env.NEXT_PUBLIC_COOKIE_DOMAIN || ".reassurez-moi.fr"
}

/**
 * Get cookie value by name
 */
export function getCookie(name: string): string | null {
    if (typeof document === "undefined") return null

    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
        return parts.pop()?.split(";").shift() || null
    }
    return null
}

/**
 * Set cookie with specified name, value and expiration days
 */
export function setCookie(name: string, value: string, days: number = 7, domain?: string) {
    if (typeof document === "undefined") return

    const cookieDomain = domain || getCookieDomain()
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;domain=${cookieDomain}`
}

/**
 * Delete cookie by name
 */
export function deleteCookie(name: string, domain?: string) {
    if (typeof document === "undefined") return

    const cookieDomain = domain || getCookieDomain()
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${cookieDomain}`
}

/**
 * Check if a cookie exists
 */
export function hasCookie(name: string): boolean {
    return getCookie(name) !== null
}
